export default __webpack_public_path__ + "assets/upload_logo_image.e0b061.png";